import { Box, BoxProps, Heading, Text } from '@chakra-ui/react';
import TransText from 'next-translate/TransText';
import { ReactNode } from 'react';

import { useFluidSize } from '../../../utils/hooks';

type Props = BoxProps & {
  title: string;
  body: string;
  children?: ReactNode;
};

export const NewsletterSubscriptionContent = ({ title, body, children, ...boxProps }: Props) => {
  const titleFontSize = useFluidSize('xl', '4xl', 'sm');

  return (
    <Box {...boxProps}>
      <Heading as="h2" fontSize={titleFontSize} fontWeight="light">
        {title}
      </Heading>

      <Text fontSize={{ base: 'sm', md: 'md' }} lineHeight={1.5} mt="space.8">
        <TransText
          text={body}
          components={{
            b: <Text as="strong" fontWeight="medium" />,
          }}
        />
      </Text>

      {children}
    </Box>
  );
};
